import React, { useEffect, useState } from "react";

import CircularProgress from "@material-ui/core/CircularProgress";
import { Typography } from "@material-ui/core";

export const relationRenderer = (value, dataSource) => {
    const [loading, setLoading] = useState(true);
    const [currentValue, setCurrentValue] = useState(0);

    useEffect(() => {
        if (value < 1) return setLoading(false);
        (async () => {
            const related = (await dataSource.id(value)).data;
            if (typeof related === "object" && related.id)
                setCurrentValue(related);
        })();
        setLoading(false);
    }, []);

    return loading ? (
        <CircularProgress size={24} />
    ) : (
        <Typography>
            {currentValue !== 0 ? currentValue.name : "Отсутствует"}
        </Typography>
    );
};
